import React from 'react';
import { useHistory } from 'react-router-dom';

import SupportRequestPresenter from '../../../../../../presenters/SupportRequestPresenter';
import appRoutes from '../../../../../../routes/appRoutes';
import Button from '../../../../../../components/Button';
import { ElementLink } from '../../../../../../components';

const SupportRequest = (props) => {
  const { request } = props;
  const auth0Id = SupportRequestPresenter.userAuth0Id(request);
  const history = useHistory();

  const handleRedirectToFastCash = (e) => {
    e.stopPropagation();
    const path = appRoutes.userFastCashPath({ byAuth0Id: auth0Id });

    history.push(path);
  };

  return (
    <ElementLink
      element="tr"
      to={appRoutes.supportRequestPath(SupportRequestPresenter.id(request))}
    >
      <td>{SupportRequestPresenter.createdAt(request)}</td>
      <td>
        <div className="truncated-field">
          {SupportRequestPresenter.userEmail(request)}
        </div>
        <Button
          className="nav-button truncated-field"
          onClick={handleRedirectToFastCash}
          role="link"
        >
          {auth0Id}
        </Button>
      </td>
      <td>{SupportRequestPresenter.date(request)}</td>
      <td>{SupportRequestPresenter.amountReadable(request)}</td>
      <td>{SupportRequestPresenter.storeName(request)}</td>
      <td>{SupportRequestPresenter.state(request)}</td>
      <td className="truncated-field">
        {SupportRequestPresenter.reviewerCommentReadable(request)}
      </td>
    </ElementLink>
  );
};

SupportRequest.propTypes = {
  request: SupportRequestPresenter.shape().isRequired,
};

export default SupportRequest;
